import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataForm from "components/UI/form/DataForm";
import { fetchDataAction, fetchDataActionPostMethod } from "store/features/coreSlice";
import PropTypes from "prop-types";
import dataVal from "../../dataVal.json";

const FilterForm = ({ setNumber, setUrl, baseUrl, setLibraryId }) => {
  const dispatch = useDispatch();
  const { filterproducts, filterlibraries, filterpublisher, limit } = useSelector(
    (state) => state.core
  );
  const [data, setData] = useState([]);
  const [filteredValues, setFilteredValues] = useState(null);
  const [publisherId, setPublisherId] = useState(null);

  const [initialValues, setInitialValues] = useState(dataVal.initialValuesFilter);

  const orgData = () => {
    setData([
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "book_id",
        id: "book_id",
        label: "book_id",
        data: filterproducts,
        size: 4,
        title: "book",
      },
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "publisher_id",
        id: "publisher_id",
        label: "publisher_id",
        data: filterpublisher,
        size: 2,
        title: "publisher",
      },
      {
        type: "Select",
        optionTitle: "title",
        name: "library_id",
        id: "library_id",
        label: "library_id",
        data: filterlibraries,
        size: 2,
        title: "libraries",
      },
      {
        type: "Date",
        name: "start_date",
        id: "start_date",
        label: "start_date",
        size: 2,
        title: "startBuyingDate",
      },
      {
        type: "Date",
        name: "end_date",
        id: "end_date",
        label: "end_date",
        size: 2,
        title: "endBuyingDate",
      },
    ]);
  };

  useEffect(() => {
    if (filterproducts && filterlibraries && filterpublisher) orgData();
  }, [filterproducts, filterlibraries, filterpublisher]);

  const generateUrl = (values) => {
    let str = baseUrl;
    const keys = Object.keys(values);
    keys.forEach((element) => {
      if (values[element]) {
        if (element === "book_id") str += `&filter[${element}.id]=${values[element].id}`;
        else if (element === "publisher_id")
          str += `&filter[book_id.publisher]=${values[element].id}`;
        else if (element === "library_id") {
          setLibraryId(values.library_id);
          str += `&filter[stores.distributions.library_id.id]=${values[element].id}`;
        }
      }
    });

    if (values.start_date && values.end_date)
      str += `&filter[buying_date][between]=${values.start_date} , ${values.end_date}`;
    else if (values.start_date) str += `&filter[buying_date][gt]=${values.start_date}`;
    else if (values.end_date) str += `&filter[buying_date][lt]=${values.end_date}`;
    return str;
  };

  const setFieldSelectedValue = (name, values) => {
    if (name === "publisher_id") {
      setPublisherId(values.id);
      dispatch(
        fetchDataAction({
          url: `items/products?fields=id,arabic_title,publisher&filter[publisher]=${values.id}`,
          varName: "filterproducts",
        })
      );
    }
  };

  const onChangeHandler = (name, text) => {
    if (name === "publisher_id") {
      dispatch(
        fetchDataAction({
          url: `items/publisher?fields=id,arabic_title&filter[arabic_title][${
            text ? `contains]=${text}` : "nempty]=true"
          }&limit=${limit}`,
          varName: "filterpublisher",
        })
      );
    }

    let url;
    if (name === "book_id") {
      url = `items/products?fields=id,arabic_title&filter[arabic_title][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (publisherId) url += `&filter[publisher]=${publisherId}`;

      dispatch(
        fetchDataAction({
          url,
          varName: "filterproducts",
        })
      );
    }

    if (name === "library_id")
      dispatch(
        fetchDataAction({
          url: `items/libraries?fields=id,title&filter[title][${
            text ? `contains]=${text}` : "nempty]=true"
          }&limit=${limit}`,
          varName: "filterlibraries",
        })
      );
  };

  const setPayload = (values) => {
    setFilteredValues(values);
    setNumber(1);
    if (values) setInitialValues(values);
    setUrl(generateUrl(values));
    dispatch(
      fetchDataAction({
        url: `${generateUrl(values)}&meta=*&limit=${limit}&page=${1}`,
        varName: "buyingsRep",
      })
    );
    dispatch(
      fetchDataActionPostMethod({
        url: `custom/getDistributionReportTotal`,
        varName: "distributionReportTotal",
        data: values,
      })
    );
  };

  const getData = (dataNeeded) => {
    dataNeeded.forEach((element) => {
      if (element === "libraries")
        dispatch(
          fetchDataAction({
            url: `items/${element}?fields=id,title&limit=${limit}`,
            varName: `filter${element}`,
          })
        );
      else
        dispatch(
          fetchDataAction({
            url: `items/${element}?fields=id,arabic_title&limit=${limit}`,
            varName: `filter${element}`,
          })
        );
    });
  };

  useEffect(() => {
    getData(dataVal.oterData);
  }, []);

  useEffect(() => {
    setPayload(filteredValues || initialValues);
  }, [limit]);

  if (data.length === 0) {
    return null;
  }

  return (
    <DataForm
      filter
      yupObj={{}}
      name="researchFilter"
      data={data}
      initialValues={initialValues}
      setPayload={setPayload}
      setFieldSelectedValue={setFieldSelectedValue}
      onChange={onChangeHandler}
    />
  );
};

FilterForm.propTypes = {
  setUrl: PropTypes.func.isRequired,
  setLibraryId: PropTypes.func.isRequired,
  setNumber: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
};
export default FilterForm;
